import { onPageLoad } from './helpers/index.js';

import icon from './components/icon.js';

import secondaryNav from './components/secondary-nav.js';
import accordion from './components/accordion.js';
import dropdown from './components/dropdown.js';
import tooltip from './components/tooltip.js';
import popup from './components/popup.js';
import validatedForm from './components/validated-form.js';
import ProductModule from './components/product-module.js';
import Slider from './components/slider.js';
import HpStripeBanner from './components/hp-stripe-banner.js';

onPageLoad(async () => {
	window.StandardUI = {};

	// single-init components

	// Note: the Icon component tracks its own MutationObserver as it needs to watch attributes with a specific filter.
	icon.init();

	// dynamic components

	const init = () => {
		secondaryNav.init();
		accordion.init();
		dropdown.init();
		tooltip.init();
		popup.init();
		validatedForm.init();
		ProductModule.init();
		Slider.init();
		HpStripeBanner.init();
	};

	// watch document for changes
	init();
	const observer = new MutationObserver(init);
	observer.observe(document, {
		childList: true,
		subtree: true
	});
});
